<template>
	<div class="custom-scrollbar ownerManagerListBody" style="height: 100%;">
		<div class="page_top_form">
			<el-form ref="form" label-width="90px">
				<el-form-item label="业主编号">
					<el-input v-model="rfid" placeholder="请输入业主编号" maxlength="20" style="width:160px;" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="姓名">
					<el-input v-model="name" placeholder="请输入业主姓名" maxlength="20" style="width:160px;" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="电话">
					<el-input v-model="mobile" placeholder="请输入业主电话" maxlength="20" style="width:160px;" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="关联设备">
					<el-select v-model="isBindDevice" placeholder="请选择" style="height: 30px;width: 120px;">
						<el-option v-for="item in relateStatusList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="余额告警">
					<el-select v-model="warning" placeholder="请选择" style="height: 30px;width: 120px;">
						<el-option v-for="item in balanceAlertChoice" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-button type="primary" size="mini" @click="search">查询</el-button>
					<el-button type="primary" size="mini" @click="addNewOwner">新增业主</el-button>
					<el-button type="danger" size="mini" @click="deleteBatches">批量删除</el-button>
					<el-button type="primary" size="mini" @click="exportReport">导出</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div class="ownerList">
			<!--custom-scrollbar-->
			<!--业主列表-->
			<el-table :data="dataList" border height="802" style="width: 100%;height:94%;" v-loading="loading">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="rfid" label="业主编号">
				</el-table-column>
				<el-table-column prop="username" label="姓名">
				</el-table-column>
				<el-table-column prop="mobile" label="联系方式">
				</el-table-column>
				<el-table-column prop="address" label="地址">
				</el-table-column>
				<el-table-column prop="gender" label="性别">
				</el-table-column>
				<el-table-column prop="isBindDevice" label="是否关联电表">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="top">
							<p>电表名称: {{ scope.row.deviceNames }}</p>
							<div slot="reference" class="name-wrapper">
								<el-tag size="medium">{{ scope.row.isBindDevice?"已关联":"未关联" }}</el-tag>
							</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column prop="isBindWaterDevice" label="是否关联水表">
					<template slot-scope="scope">
						<el-popover trigger="hover" placement="top">
							<p>水表名称: {{ scope.row.deviceNames }}</p>
							<div slot="reference" class="name-wrapper">
								<el-tag size="medium">{{ scope.row.isBindWaterDevice?"已关联":"未关联" }}</el-tag>
							</div>
						</el-popover>
					</template>
				</el-table-column>

				<el-table-column prop="balance" label="账户余额(元)">
					<template slot-scope="scope">
						<p>{{ scope.row.balance ? (scope.row.balance/100).toFixed(2) : '0.00'}}</p>
					</template>
				</el-table-column>

				<el-table-column prop="power" label="剩余电量(度)">
					<template slot-scope="scope">
						<p>{{ scope.row.power ? (scope.row.power).toFixed(2) : '0.00'}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="accountTime" label="开户时间" :formatter="formatTime">
				</el-table-column>
				<el-table-column label="操作" width="380">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" @click="viewDetails(scope.row)" plain>详情</el-button>
						<el-button size="mini" type="primary" @click="editOwnerInfo(scope.row)" plain>编辑</el-button>
						<el-button size="mini" type="primary" @click="refundClick(scope.row)" plain>退费</el-button>
						<el-button size="mini" type="danger" @click="deleteOwnerInfo(scope.row)">删除</el-button>
						<el-button size="mini" type="danger" @click="amountOfDeduction(scope.row)">补扣</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!--分页-->
			<elPagination :total="total" :pageSize="pageSize" @pageindexChange="pageindexChange" @handleSizeChange="handleSizeChange" />
		</div>
		<!--退费弹窗-->
		<el-dialog title="退费" :visible.sync="refundShow">
			<el-form :model="refundForm">
				<el-form-item label="退费设备" :label-width="formLabelWidth">
					<div style="float: right;width: 200px;margin-right: 195px">
						<el-select v-model="device" collapse-tags placeholder="请选择" size='small'>
							<el-option v-for="(item,index) in userDeviceInfo" :key="index" :label="item.deviceName" :value="item">
							</el-option>
						</el-select>
					</div>
				</el-form-item>

				<el-form-item label="用户编号" :label-width="formLabelWidth">
					<el-input v-model="refundForm.userNumber" autocomplete="off" disabled></el-input>
				</el-form-item>
				<el-form-item label="用户名" :label-width="formLabelWidth">
					<el-input v-model="refundForm.userName" autocomplete="off" disabled></el-input>
				</el-form-item>
				<el-form-item label="地址" :label-width="formLabelWidth">
					<el-input v-model="refundForm.address" autocomplete="off" disabled></el-input>
				</el-form-item>

				<el-form-item v-if="device.meterRunType==1 && device.accountType==1" label="剩余电量" :label-width="formLabelWidth">
					<el-input disabled v-model="device.electricity" autocomplete="off"></el-input>
				</el-form-item>

				<el-form-item v-if="device.meterRunType==1 && device.accountType==1" label="电量转换金额" :label-width="formLabelWidth">
					<el-input disabled v-if="device.electricity ==0" autocomplete="off" placeholder="0"></el-input>
					<el-input disabled v-else v-model="device.electricity/device.conversionRate" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="退费金额(元)" :label-width="formLabelWidth" required>
					<el-input v-if="device.meterRunType==1 && device.accountType==1" v-model="refundForm.refundAmount" type="number" class="numberInput" autocomplete="off" :placeholder="refundPlace=device.electricity/device.conversionRate"></el-input>
					<el-input v-else v-model="refundForm.refundAmount" type="number" class="numberInput" autocomplete="off" :placeholder="refundPlace"></el-input>
				</el-form-item>
				<el-form-item label="密码" :label-width="formLabelWidth" required>
					<el-input v-model="confirmPassword" type="password" autocomplete="off" placeholder="请输入密码"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="refundShow = false && setDeviceNull">取 消</el-button>
				<el-button type="primary" @click="confirmRefund">确 定</el-button>
			</div>
		</el-dialog>
		<!--补扣弹窗-->
		<el-dialog title="补扣" :visible.sync="amountOfDeductionShow">
			<el-form :model="deduction">
				<el-form-item label="补扣类型" :label-width="formLabelWidth">
					<el-select v-model="deduction.type" placeholder="补扣类型">
						<el-option label="补" value="补"></el-option>
						<el-option label="扣" value="扣"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="金额(元)" :label-width="formLabelWidth" required>
					<el-input v-model="deduction.balance" type="number" class="numberInput" autocomplete="off" placeholder="请输入补扣金额"></el-input>
				</el-form-item>
				<el-form-item label="补扣原因" :label-width="formLabelWidth">
					<el-input v-model="deduction.desc" type="text" class="numberInput" autocomplete="off" placeholder="请输入补扣原因"></el-input>
				</el-form-item>
				<p style="color: red">*补扣操作会直接更改业主的账户余额请谨慎使用</p>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="amountOfDeductionShow = false">取 消</el-button>
				<el-button type="primary" @click="amountOfDeductionConfirm">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import infoListMultipleSelection from './infoListMultipleSelection.vue'
	import singleSelection from '@/components/module/selection/singleSelection.vue'
	import ownerManagerStore from './ownerManagerStore.js'
	import elPagination from "@/components/module/elComponents/elPagination.vue"
	export default {
		components: {
			infoListMultipleSelection,
			singleSelection,
			elPagination
		},
		props: {},
		data() {
			return {
				pageIndex: 1,
				pageSize: 20,
				total: 0,
				userDeviceInfo: [],
				dataList: [],
				device: '',
				rfid: '',
				name: '',
				mobile: '',
				isBindDevice: undefined,
				isBindWaterDevice: undefined,
				warning: '',
				chargeMode: '',
				searchChange: false,
				//补扣对象
				deduction: {
					id: "",
					balance: 0,
					userName: "",
					type:"补",
					desc: "" //补扣原因
				},
				options: [{
					value: 'false',
					label: '否'
				}, {
					value: 'true',
					label: '是'
				}],
				formLabelWidth: '120px',
				refundShow: false,
				amountOfDeductionShow: false,
				refundForm: {
					userNumber: '',
					userName: '',
					address: '',
					refundAmount: '',
					remarks: '',
					userId: '',
				},

				refundPlace: "",
				selectBalance: "", //当前的金额
				confirmPassword: '', //密码
				loading: false, //列表加载
			}
		},
		created() {},
		mounted() {
			this.search()
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.state.nowUnit
			},
			chargeModeList() {
				return ownerManagerStore.state.chargeModeList
			},
			relateStatusList() {
				return ownerManagerStore.state.deviceStatusList
			},

			balanceAlertChoice() {
				return [{
					'label': '告警',
					'value': 0
				}, {
					'label': '不告警',
					'value': 1
				}]
			},

			columns() {
				return ownerManagerStore.state.columns
			},
		},
		watch: {
			dataList(nv, ov) {
				ownerManagerStore.commit('getBindedDeviceNos')
			},
			nowUnit(nv, ov) {
				this.getOwnerList(nv)
			},
			rfid(nv, ov) {
				this.searchChange = true
			},
			name(nv, ov) {
				this.searchChange = true
			},
			mobile(nv, ov) {
				this.searchChange = true
			},
			isBindDevice(nv, ov) {
				this.searchChange = true
			},
			isBindWaterDevice(nv, ov) {
				this.searchChange = true
			},
			pageIndex() {
				this.search()
			}
		},
		methods: {
			refundClick(val) {

				this.getUserDeviceList(val);

				//退费
				this.refundForm.userNumber = val.rfid
				this.refundForm.userName = val.username
				this.refundForm.address = val.address
				this.selectBalance = val.balance
				this.refundPlace = '最多可退' + (val.balance / 100).toFixed(2) + '元'
				this.refundForm.userId = val.userId
				this.confirmPassword = ''
				this.refundForm.refundAmount = ''
				this.refundForm.remarks = ''
				this.refundShow = true
			},

			setDeviceNull() {
				this.device = {};
			},

			confirmRefund() {
				if(isempty(this.confirmPassword)) {
					this.$message.error('请输入密码')
					return
				}

				if(isempty(this.device)) {
					this.$message.error("请选择退款设备");
					return
				}

				if(this.refundForm.refundAmount == 0) {
					this.$message.error("账户余额为0，无需退费");
					return
				}

				if(this.refundForm.refundAmount < 0) {
					this.$message.error("'用户账户存在欠款，请充值");
					return
				}

				if(isempty(this.refundForm.refundAmount)) {
					this.$message.error('退费金额或者输入格式不对！')
					return
				}

				var refType = 1; //1==退余额；2==退电量
				if(this.device.accountType == 1 && this.device.meterRunType == 1) {

					if(this.refundForm.refundAmount > (this.device.electricity / this.device.conversionRate)) {
						this.$message.error('退款金额大于账户余额')
						return
					}

					//退电量  金额线下退还
					//this.refundForm.refundAmount = this.refundForm.refundAmount * this.device.conversionRate;
					refType = 2;

				} else {

					if(this.refundForm.refundAmount * 100 > this.selectBalance) {
						this.$message.error('退款金额大于账户余额')
						return
					}

					this.refundForm.refundAmount = this.refundForm.refundAmount * 100;

				}
				//退费
				this.$api.meterReadingApi.refundAmount(this.device.conversionRate, this.device.deviceNo, refType, this.refundForm.userId, this.refundForm.refundAmount, hex_md5(this.confirmPassword), respon => {
					this.$message.success(respon)
					this.search()
					this.refundShow = false
				}, err => {
					this.$message({
						type: 'error',
						message: err
					});
				})

				this.setDeviceNull();
			},
			//当前页
			pageindexChange(val) {
				this.pageIndex = val;
				this.search()
			},
			//页大小
			handleSizeChange(val) {
				this.pageSize = val;
				this.pageIndex = 1;
				this.search()
			},
			// 选择计费方式
			selectChargeMode(item) {
				this.chargeMode = item.value
			},
			addNewOwner() {
				this.$emit('add')
			},
			viewDetails(item) {
				this.$emit('view', item)
			},
			editOwnerInfo(item) {
				this.$emit('edit', item)
				ownerManagerStore.commit('setOwnerEditing', item)
			},
			deleteOwnerInfo(item) {
				this.getUserDeviceList(item);
				this.$confirm("确认删除业主编号：" + item.rfid + ' 姓名：' + item.username + '的业主信息？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if(!this.deleteCheck(item)) {
						return
					}

					this.$api.userApi.deleteUserById(item.id, respon => {
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
						this.search()
						ownerManagerStore.commit('getAllOwnerRfidList')
						ownerManagerStore.commit('getBindedDeviceNos')
						ownerManagerStore.commit('getDeviceNos', this.nowUnit.id)

					}, message => {
						this.$message(message)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},

			//业主设备列表
			getUserDeviceList(val) {
				this.$api.meterReadingApi.getUserDeviceList(val.userId, respon => {
					this.userDeviceInfo = respon;
				})
			},

			amountOfDeduction(val) {
				//退费
				this.deduction.userName = val.username
				this.deduction.id = val.userId
				this.amountOfDeductionShow = true
			},
			amountOfDeductionConfirm() {
				//补扣
				if(!this.deductionCheck()) {
					return;
				}
				this.$confirm("确认业主：" + this.deduction.userName + ','+this.deduction.type + this.deduction.balance + "元?", '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//补扣
					this.$api.userApi.amountOfDeduction(this.deduction.id, this.deduction.balance, this.deduction.desc,this.deduction.type,respon => {
						this.$message({
							type: 'success',
							message: '补扣成功!'
						});
						this.search()
						ownerManagerStore.commit('getAllOwnerRfidList')
						ownerManagerStore.commit('getBindedDeviceNos')
						ownerManagerStore.commit('getDeviceNos', this.nowUnit.id)
						this.deduction.balance = ""
						this.deduction.desc = ""
						this.amountOfDeductionShow = false
					}, message => {
						this.$message(message)
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消补扣'
					});
				});
			},

			deductionCheck() {
				if(this.deduction.balance <= 0) {
					this.$message.error('请输入正确的补扣金额')
					return false;
				}

				if(this.deduction.desc == "") {
					this.$message.error('请输入补扣原因')
					return false;
				}

				return true;

			},

			// 批量删除
			deleteBatches() {
				var keys = Object.keys(this.$refs.infoList.nowSelectIds)
				var ownerIds = []
				keys.forEach(key => {
					if(this.$refs.infoList.nowSelectIds[key]) {
						ownerIds.push(key)
					}
				})
				if(ownerIds.length <= 0) {
					this.$dialogMethod.showMessage('请选择要批量删除的业主！')
					return
				}
				this.$api.userApi.deleteUserById(ownerIds.join(','), respon => {
					this.$dialogMethod.showMessage('批量删除业主成功！')
					this.search()
					ownerManagerStore.commit('getAllOwnerRfidList')
					ownerManagerStore.commit('getBindedDeviceNos')
				}, message => {
					this.$dialogMethod.showMessage(message)
				})
			},
			exportReport() {
				this.$store.cacheStore.state.load = true
				this.$api.meterReadingApi.exportOwnerList(this.rfid, this.name, this.mobile, this.isBindDevice == '' ? false : this.isBindDevice, this.warning, respon => {
					this.$store.cacheStore.state.load = false
					saveAs(DWSystemSetting.downloadUrl + '/' + respon, '业主信息表' + ".xls")
				})
			},
			search() {
				this.getOwnerList(this.nowUnit)
			},
			getOwnerList(unit) {
				if(!unit || !unit.id) {
					return
				}
				this.loading = true
				this.$api.meterReadingApi.getOwnerList(unit.id, this.pageIndex, this.pageSize, this.rfid, this.name, this.mobile, this.isBindDevice, this.warning, respon => {
					this.total = respon.total
					this.dataList = respon.dataList
					this.loading = false
				})
			},
			// 切换每页显示条数
			pageSizeChange(pageSize) {
				this.pageIndex = 1
				this.pageSize = pageSize
				this.search()
			},
			// 切换当前显示页码
			jumpToPage(pageIndex) {
				this.pageIndex = pageIndex
				this.search()
			},
			formatTime(row, column, cellValue) {
				return new Date(row.accountTime).format('yyyy-MM-dd')
			},

			//删除业主、批量删除业主  判断
			deleteCheck(item) {
				if(item.balance != 0 && !isempty(item.balance)) {
					this.$message.error('用户账户未结算，请先结算')
					return false;
				}

				let deviceList = this.userDeviceInfo;

				this.userDeviceInfo.forEach(function(value, index, deviceList) {
					if(value.electricity != 0 && !isempty(value.electricity)) {
						this.$message.error('电表剩余电量未清零')
						return false;
					}
				})
				return true;
			}

		}
	}
</script>
<style>
	.ownerManagerListBody .el-dialog {
		width: 30% !important;
	}
	
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
	
	input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
<style scoped>
	.ownerList {
		padding: 0 20px 0 20px;
		height: calc(100% - 73px);
	}
	
	.ownerList::-webkit-scrollbar {
		width: 10px;
		height: 10px;
	}
	
	.ownerList::-webkit-scrollbar-track {
		box-shadow: none;
		background-color: #FFFFFF;
	}
	
	.ownerList:hover::-webkit-scrollbar-track {
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
		background-color: #F0F0F0;
	}
	
	.ownerList::-webkit-scrollbar-thumb {
		background-color: #FFFFFF;
	}
	
	.ownerList:hover::-webkit-scrollbar-thumb {
		background-color: #CACACA;
	}
	
	.ownerList>div {
		width: calc(100% - 10px);
	}
	
	.normalStatus {
		display: inline-block;
		border: solid 1px #87CF64;
		border-radius: 4px;
		color: #87CF64;
		background-color: #F0F9EC;
		line-height: 28px;
		padding: 0 6px;
	}
	
	.wrongStatus {
		display: inline-block;
		border: solid 1px #F9A6A6;
		border-radius: 4px;
		color: #F9A6A6;
		background-color: #FEF1F1;
		line-height: 28px;
		padding: 0 6px;
	}
	
	.waitStatus {
		display: inline-block;
		border: solid 1px #E6A23C;
		border-radius: 4px;
		color: #E6A23C;
		background-color: #FDF6EC;
		line-height: 28px;
		padding: 0 6px;
	}
	
	.normalStatus:hover,
	.wrongStatus:hover,
	.waitStatus:hover {
		background: #ECF5FF;
		color: #409EFF;
		border: solid 1px #409EFF;
	}
	
	.operateBtn {
		display: inline-block;
		border-radius: 4px;
		line-height: 28px;
		padding: 0 6px;
		background: #ECF5FF;
		color: #409EFF;
		border: solid 1px #409EFF;
		margin-right: 8px;
		cursor: pointer;
	}
	
	.operateBtn:last-child {
		margin-right: 0;
	}
	
	@media screen and (max-width: 1500px) {
		.ownerList {
			height: calc(100% - 96px);
		}
	}
</style>